import { render, staticRenderFns } from "./TransactionsCenter.vue?vue&type=template&id=fa04786e&scoped=true&"
import script from "./TransactionsCenter.vue?vue&type=script&lang=ts&"
export * from "./TransactionsCenter.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsCenter.vue?vue&type=style&index=0&id=fa04786e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04786e",
  null
  
)

export default component.exports